export default __webpack_public_path__ + "static/media/accessible-updated-certs.4bd49460.png";